<script setup lang="ts">
import { useGlobalSearch } from '../model/model.ts'
import { isSearchResultElement, useGlobalSearchNavigation } from '../model/helpers.ts'
import { VIcons } from '@/shared/ui'
import type { GlobalSearchType } from '../model/type.ts'
import { storeToRefs } from 'pinia'
import { useTranslate } from '@/shared/lib'
import { computed } from 'vue'

const { trs } = useTranslate()

const model = useGlobalSearch()
const { navigateTo } = useGlobalSearchNavigation()
const { isFetching } = storeToRefs(model)

const headers = [
  { key: 'object_name', title: trs('itf.object_name'), sortable: true },
  { key: 'object_type_name', title: trs('itf.object_type_elem'), sortable: true },
  { key: 'actions', sortable: false, align: 'end' as const },
]

type SortItem = {
  key: string
  order?: 'asc' | 'desc'
}

/** Вычисляемая сортировка */
const sortBy = computed<SortItem[]>({
  get: () =>
    model.query.sort_by
      ? [{ key: model.query.sort_by, order: model.query.sort_order ?? 'asc' }]
      : [],
  set: ([sort]) => {
    model.query.sort_by = sort?.key ?? null
    model.query.sort_order = sort?.order ?? null
  },
})

/**
 * Открывает выбранный результат из серверной таблицы.
 */
const rowClickHandler = (_: PointerEvent, { item }: { item: GlobalSearchType }) => {
  navigateTo(item)
}
</script>

<template>
  <VDataTableServer
    class="table_hover"
    v-model:items-per-page="model.query.limit"
    v-model:page="model.query.page"
    v-model:sort-by="sortBy"
    :loading="isFetching"
    :items="model.result"
    :items-length="model.total"
    :headers="headers"
    :items-per-page-options="[20, 50, 100]"
    @click:row="rowClickHandler"
  >
    <template #item.actions="{ item }: { item: GlobalSearchType }">
      <VTooltip v-if="isSearchResultElement(item.type)" location="top" :text="$t('itf.map')">
        <template #activator="{ props }">
          <VBtn
            v-bind="props"
            icon
            density="compact"
            @click.stop="navigateTo(item, true)"
          >
            <VIcons type="location_on" />
          </VBtn>
        </template>
      </VTooltip>
    </template>
  </VDataTableServer>
</template>
